import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OktaAuthGuard } from '../shared/services';
import { ApiDocsComponent } from './api-docs/api-docs.component';

const routes: Routes = [
        {
        path: 'contextual/dashboard',
        loadChildren: '../contextual/dashboard/ctx-dashboard.module#CtxDashboardModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'contextual/segment',
        loadChildren: '../contextual/segment/ctx-segment.module#CtxSegmentModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'liveramp-ids',
        loadChildren: '../dashboard/dashboard.module#DashboardModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'dashboard',
        loadChildren: '../dashboard/dashboard.module#DashboardModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'segment',
        loadChildren: './../segment/segment.module#SegmentModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'faulty-segments',
        loadChildren: '../dashboard/dashboard.module#DashboardModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'segment-type-selection',
        loadChildren: '../segment-type-selection/segment-type-selection.module#SegmentTypeSelectionModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'custom-contextual-form',
        loadChildren: '../custom-contextual-form/custom-contextual-form.module#CustomContextualFormModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'cohort-intelligence-form',
        loadChildren: '../prompted-contextual-form/prompted-contextual-form.module#PromptedContextualFormModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'cohort-intelligence-beta',
        loadChildren: '../multi-vector-form/multi-vector-form.module#MultiVectorFormModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'consumership-form',
        loadChildren: '../consumership-form/consumership-form.module#ConsumershipFormModule',
        canActivate: [OktaAuthGuard],
    },
    {
        path: 'api-docs',
        component: ApiDocsComponent,
        // No canActivate - publicly accessible
    },
    {
        path: '**',
        redirectTo: 'dashboard',
        canActivate: [OktaAuthGuard],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: true }),
    ],
    exports: [
        RouterModule,
    ],
})

export class AppRoutingModule {}
